<template>
  <div class="bg-white">
    <div class="flex justify-between items-start shadow-border-b mdmax:flex-col">
      <div class="flex-1 shadow-border-r mdmax:shadow-border-b mdmax:flex-auto mdmax:w-full">
        <div class="shadow-border-b p-6">
          <p class="font-bold text-lg mb-6">Info Kurir</p>
          <div class="mb-6">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">ID</label>
            <p class="text-neutral-500">{{ courierDetail.id }}</p>
          </div>
          <div class="mb-6 flex gap-6">
            <div class="w-44 mdmax:flex-1 mdmax:w-auto">
              <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Nama</label>
              <p class="text-neutral-500">{{ courierDetail.name }}</p>
            </div>
            <div class="w-44 mdmax:flex-1 mdmax:w-auto">
              <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">No. Handphone</label>
              <p class="text-neutral-500">{{ courierDetail.phone_number }}</p>
            </div>
          </div>
          <div class="mb-6 flex gap-6">
            <div class="w-44 mdmax:flex-1 mdmax:w-auto">
              <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Jenis Kelamin</label>
              <p class="text-neutral-500">{{ genderMapping[courierDetail.gender] }}</p>
            </div>
            <div class="w-44 mdmax:flex-1 mdmax:w-auto">
              <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Email</label>
              <p class="text-neutral-500">{{ courierDetail.email }}</p>
            </div>
          </div>
          <div class="flex gap-6">
            <div class="w-44 mdmax:flex-1 mdmax:w-auto">
              <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Area</label>
              <p class="text-neutral-500">{{ courierDetail.area_name }}</p>
            </div>
            <div class="w-44 mdmax:flex-1 mdmax:w-auto">
              <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Status</label>
              <p class="text-neutral-500">{{ courierDetail.availability_status }}</p>
            </div>
          </div>
        </div>
        <div class="flex-1 p-6 mdmax:flex-auto mdmax:w-full">
          <p class="font-bold text-lg mb-6">KTP & SIM</p>
          <div class="mb-6">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">No KTP</label>
            <p class="text-neutral-500">{{ courierDetail.id_card_number }}</p>
          </div>
          <div class="mb-6">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Tipe SIM</label>
            <p class="text-neutral-500">{{ courierDetail.driver_license_type }}</p>
          </div>
          <div class="">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">No SIM</label>
            <p class="text-neutral-500">{{ courierDetail.driver_license_number }}</p>
          </div>
        </div>
      </div>
      <div class="flex-1 p-6 mdmax:flex-auto mdmax:w-full">
        <p class="font-bold text-lg mb-6">Informasi Bank</p>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Nama Bank</label>
          <p class="text-neutral-500">{{ courierDetail.bank_name }}</p>
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">No. Rekening</label>
          <p class="text-neutral-500">{{ courierDetail.bank_account }}</p>
        </div>
        <div class="">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Pemilik Rekening</label>
          <p class="text-neutral-500">{{ courierDetail.bank_account_holder }}</p>
        </div>
      </div>
    </div>
    <div class="flex gap-6 p-6 justify-end mdmax:justify-center">
      <Button buttonText="Hapus" @action="submit()" type="delete" :size="isMobile ? 'full' : 'regular'" />
      <Button buttonText="Edit" @action="submit()" :size="isMobile ? 'full' : 'regular'" />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  components: {
    Button: () => import(/* webpackChunkName: "form" */ '@/components/Forms/Button')
  },
  data() {
    return {
      genderMapping: {
        M: 'Laki-laki',
        F: 'Perempuan'
      }
    }
  },
  computed: {
    ...mapGetters('common', ['isMobile']),
    ...mapGetters('courier', ['courierDetail']),
    courierId() {
      return this.$route.params.id
    }
  },
  created() {
    this.getCourierInfo()
  },
  methods: {
    ...mapActions('courier', ['getCourierDetail']),
    getCourierInfo() {
      this.getCourierDetail({
        courierId: this.courierId
      })
    }
  }
}
</script>
